<script setup lang="ts">
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import IconAtom from '@/components/atoms/IconAtom.vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';
  import InputAtom from '@/components/atoms/InputAtom.vue';

  const props = defineProps<{ details: any }>();
  const emit = defineEmits(['updateDetails']);

  const localDetails = ref({ 
    ...props.details
  });
  const coverImage = ref<string | null>(null);
  const uploadedImg = ref<HTMLInputElement | null>(null);

  const maxTitleLength = 30;
  const maxDescriptionLength = 80;

  watch(
    () => props.details,
    (newValue) => {
      localDetails.value = { ...newValue };
      coverImage.value = localDetails.value.banner;
    },
    { immediate: true, deep: true },
  );

  function triggerImgUpload() {
    uploadedImg.value?.click();
  }

  function imgupload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      coverImage.value = e.target?.result as string;
    };
    reader.readAsDataURL(file);
    localDetails.value.banner = file;
  }

  function clearImage() {
    coverImage.value = null;
    localDetails.value.banner = '';
    if (uploadedImg.value) {
      uploadedImg.value.value = '';
    }
  }

  watch(
    localDetails,
    () => {
      emit('updateDetails', localDetails);
    },
    { deep: true },
  );
</script>

<template>
  <div class="groups-molecule">
    <label for="title">Group details</label>

    <div class="sections-container">
      <div class="cover-section">
        <div class="cover-img">
          <ButtonAtom
            class="btn btn-secondary coverBtn"
            :style="{
              backgroundImage: coverImage ? `url(${coverImage})` : '',
              border: coverImage ? 'none' : '2px dashed #ccc',
            }"
            @click="triggerImgUpload"
          >
            <IconAtom v-if="!coverImage" icon="cameraIcon" />
            <p v-if="!coverImage">Cover</p>

            <button
              v-if="coverImage"
              class="clear-image-btn"
              @click.stop="clearImage"
            >
              X
            </button>
          </ButtonAtom>
          <input
            type="file"
            ref="uploadedImg"
            accept="image/*"
            @change="imgupload"
            style="display: none"
          />
        </div>
      </div>

      <div class="details-section">
        <div class="title">
          <label for="title">Title</label>
          <InputAtom
            id="title"
            v-model="localDetails.name"
            placeholder="Name"
            class="input"
            :max-length="maxTitleLength"
          />
          <p>{{ localDetails.name.length }}/{{ maxTitleLength }}</p>
        </div>
        <div class="description">
          <label for="description">Description</label>
          <textarea
            id="description"
            placeholder="Text"
            v-model="localDetails.description"
            class="description-textarea"
            :maxlength="maxDescriptionLength"
          />
          <p>
            {{ localDetails.description.length }}/{{ maxDescriptionLength }}
          </p>
        </div>
        <div class="premium-checkbox">
          <label class="checkbox-label">
            <input
              type="checkbox"
              class="checkbox-input"
              v-model="localDetails.is_premium"
            />
            <span class="custom-checkbox"></span>
            <span class="checkbox-label-text">Premium</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./GroupsFormMolecule.css" scoped></style>
